import type { RootScope } from '../types';

UnitSearchHeaderController.$inject = ['$scope', '$rootScope'];

interface ScopeProps {
  objectId: string;
  houseId: string;
  sectionId: string;
  houseName: string;
  houseLocation: string;
  houseCity: string;

  /**
   * The same as company.currency
   * TODO: migrate to RootScope.company in future?
   */
  defaultCurrency: string | 'false';
}

export interface UnitSearchHeaderController extends ScopeProps {
  active: boolean;
  objectsNaviActive: boolean;
  objectName: string;

  /**
   * How much results in current object
   */
  objectTotal: number;

  /**
   * How much results across all company objects
   */
  companyTotal: number;
  toggleObjectsNavi: () => void;
  toggleFilters: () => void;
  resetFilters: () => void;
}

export function UnitSearchHeaderController(
  this: UnitSearchHeaderController,
  $scope: angular.IScope,
  $rootScope: RootScope,
) {
  const vm = this;
  vm.active = false;
  vm.objectsNaviActive = false;
  vm.companyTotal = 0;
  vm.objectTotal = 0;
  vm.objectName = '';

  $scope.$watch('$root.filterObjects', () => {
    if (!$rootScope.filterObjects) {
      return;
    }

    vm.companyTotal = 0;
    vm.objectTotal = 0;
    vm.objectName = '';

    for (const object of $rootScope.filterObjects) {
      if (String(object.id) === vm.objectId) {
        vm.objectName = object.name;
        vm.objectTotal = object.exact_match.length;
      } else {
        vm.companyTotal += object.exact_match.length;
      }
    }
  });

  vm.toggleFilters = () => {
    vm.active = !vm.active;

    if (vm.objectsNaviActive && vm.active) {
      vm.objectsNaviActive = false;
    }
  };

  vm.toggleObjectsNavi = () => {
    vm.objectsNaviActive = !vm.objectsNaviActive;

    if (vm.objectsNaviActive && vm.active) {
      vm.active = false;
    }
  };

  vm.resetFilters = () => {
    vm.active = false;

    // call resetQuery() in unit.search.panel.controller.ts
    $rootScope.$broadcast('unit.search.panel:resetFilters');
  };
}
